import { NodeMap } from "../Node/Node.Interface";
import { OrgInterface } from "../Org/Org.Interface";
import { InheritanceStatus, Slug } from "../Shared/Shared.Interfaces";
import { MatrixInterface } from "./Matrix.Interface";

export enum QuestType {
  NORMAL = "normal",
  MATRIX = "matrix",
  ROUTER = "router",
  DEFAULT_UNHANDLED = "default-unhandled",
  VOICE_ROUTER = "voice-router",
  GMB_ROUTER = "GMB-router",
  FBM_ROUTER = "FMB-router"
}
export interface BaseQuestInterface {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  orgId: number;
  org?: OrgInterface;
  slug: string;
  name: string;
  inheritance: InheritanceStatus;
  type: QuestType;
  journeySlug?: Slug;
  brainSlug?: Slug;
  order: number;
  data: any;
}
export interface MatrixQuestInterface extends BaseQuestInterface {
  type: QuestType.MATRIX;
  data: MatrixInterface;
}
export interface NormalQuestInterface extends BaseQuestInterface {
  type: QuestType.NORMAL | QuestType.ROUTER | QuestType.DEFAULT_UNHANDLED | QuestType.VOICE_ROUTER | QuestType.GMB_ROUTER | QuestType.FBM_ROUTER;
  data: NodeMap;
}
export declare type QuestInterface = MatrixQuestInterface | NormalQuestInterface;
export enum JourneyType {
  NORMAL = "normal",
  QUICK_REPLIES = "quick replies",
  VOICE = "voice"
}
export interface JourneyInterface {
  id: number;
  createdAt: Date;
  updatedAt: Date;
  orgId: number;
  org: OrgInterface;
  inheritance: InheritanceStatus.NONE | InheritanceStatus.IS_PARENT;
  name: string;
  slug: Slug;
  type: JourneyType;
  brainSlug?: Slug | null;
  order: number;
}
